import { useQuery } from '@apollo/client';
import { QUERY_MY_DOWNLOAD_USAGE } from '@/graphql/queries/downloads';
import { DownloadUsage } from '@/graphql/types/downloads';

export const useDownloadUsage = () => {
  const { data, loading, error, refetch } = useQuery<{
    myDownloadUsage: DownloadUsage;
  }>(QUERY_MY_DOWNLOAD_USAGE, {
    fetchPolicy: 'network-only',
  });

  const downloadUsage = data?.myDownloadUsage;
  const isLimitReached = downloadUsage ? downloadUsage.used >= downloadUsage.limit : false;

  return {
    downloadUsage,
    loading,
    error,
    refetch,
    isLimitReached,
  };
};
